import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import api from '../../services/api';

const ArticlesManager = () => {
    const { articles, fetchArticles, showToast } = useApp();
    const [search, setSearch] = useState('');
    const [categoryFilter, setCategoryFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const navigate = useNavigate();

    const filteredArticles = articles.filter(article => {
        if (search && !article.title.toLowerCase().includes(search.toLowerCase())) return false;
        if (categoryFilter && article.category !== categoryFilter) return false;
        if (statusFilter && article.status !== statusFilter) return false;
        return true;
    });

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this article?')) {
            try {
                await api.delete(`/articles/${id}`);
                await fetchArticles();
                showToast('Article deleted successfully');
            } catch (error) {
                showToast('Error deleting article', 'error');
            }
        }
    };

    const categories = [...new Set(articles.map(a => a.category))];

    return (
        <div style={{ background: '#fff', borderRadius: '8px', padding: '24px', boxShadow: '0 1px 6px rgba(0,0,0,.08)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
                <h3 style={{ margin: 0 }}>All Articles</h3>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    <input
                        type="text"
                        placeholder="Search articles..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        style={{ border: '1.5px solid #ddd', borderRadius: '5px', padding: '8px 12px', fontSize: '13px', outline: 'none' }}
                    />
                    <select
                        value={categoryFilter}
                        onChange={(e) => setCategoryFilter(e.target.value)}
                        style={{ border: '1.5px solid #ddd', borderRadius: '5px', padding: '8px 12px', fontSize: '13px', outline: 'none' }}
                    >
                        <option value="">All Categories</option>
                        {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                    </select>
                    <select
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                        style={{ border: '1.5px solid #ddd', borderRadius: '5px', padding: '8px 12px', fontSize: '13px', outline: 'none' }}
                    >
                        <option value="">All Status</option>
                        <option value="live">Live</option>
                        <option value="draft">Draft</option>
                    </select>
                    <button className="btn btn-navy btn-sm" onClick={() => navigate('/admin/add-article')}>+ New Article</button>
                </div>
            </div>
            <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ background: 'var(--navy)', color: '#fff' }}>
                            <th style={{ padding: '10px 12px', textAlign: 'left' }}>Image</th>
                            <th style={{ padding: '10px 12px', textAlign: 'left' }}>Title</th>
                            <th style={{ padding: '10px 12px', textAlign: 'left' }}>Category</th>
                            <th style={{ padding: '10px 12px', textAlign: 'left' }}>Views</th>
                            <th style={{ padding: '10px 12px', textAlign: 'left' }}>Status</th>
                            <th style={{ padding: '10px 12px', textAlign: 'left' }}>Date</th>
                            <th style={{ padding: '10px 12px', textAlign: 'left' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredArticles.map(article => (
                            <tr key={article._id}>
                                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>
                                    <img src={article.img || article.imgData} alt="" style={{ width: '60px', height: '40px', objectFit: 'cover', borderRadius: '3px' }} onError={(e) => e.target.style.display = 'none'} />
                                </td>
                                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0', maxWidth: '300px' }}>
                                    {article.title}
                                </td>
                                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>{article.category}</td>
                                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>
                                    <strong>{article.views?.toLocaleString() || 0}</strong>
                                </td>
                                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>
                                    <span className={`badge ${article.status === 'live' ? 'status-live' : 'status-draft'}`}>
                                        {article.status}
                                    </span>
                                </td>
                                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>{article.date}</td>
                                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>
                                    <button className="action-btn action-edit" onClick={() => navigate(`/admin/edit-article/${article._id}`)}>Edit</button>
                                    <button className="action-btn action-del" onClick={() => handleDelete(article._id)}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ArticlesManager;